import React from 'react';
import { THEME } from '../../utils/theme';

const RingStat = ({ value, max, color, label, size = 80 }) => {
  const pct = Math.round((value / (max || 1)) * 100);
  const circumference = 2 * Math.PI * 35;
  const strokeDasharray = `${(pct / 100) * circumference} ${circumference}`;
  return (
    <div style={{ textAlign: 'center' }}>
      <svg width={size} height={size} viewBox="0 0 80 80">
        <circle cx="40" cy="40" r="35" fill="none" stroke={THEME.bg} strokeWidth="8" />
        <circle cx="40" cy="40" r="35" fill="none" stroke={color} strokeWidth="8" strokeDasharray={strokeDasharray} strokeLinecap="round" transform="rotate(-90 40 40)" style={{ transition: 'stroke-dasharray 0.5s ease' }} />
        <text x="40" y="40" textAnchor="middle" dy="0.35em" fill={THEME.text} fontSize="16" fontWeight="700">{pct}%</text>
      </svg>
      <div style={{ fontSize: '11px', color: THEME.textMuted, marginTop: '4px' }}>{label}</div>
    </div>
  );
};

export default RingStat;
